import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export function useAnchorTag() {
  const history = useHistory();

  useEffect(() => {
    const scrollToHash = () => {
      const hash = history.location.hash;

      if (hash) {
        let cleanHash = hash;
        // remove the query string from the hash
        const queryIndex = hash.indexOf('&');
        if (queryIndex > -1) {
          cleanHash = hash.substring(0, queryIndex);
        }

        const id = cleanHash.replace('#', '');

        const element = document.getElementById(id);

        if (element) {
          // this is a workaround for Safari, which doesn't scroll to the player
          // because we use the iframeResizer library, we can sroll to the player
          if ('parentIFrame' in window) {
            const y = element.getBoundingClientRect().top + window.scrollY;
            window.parentIFrame.scrollTo(0, y);
          } else {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
          element.focus();
        }
      }
    };

    // listen to history changes and scroll to the hash
    const unlisten = history.listen(scrollToHash);

    // scroll to the hash when the component mounts
    scrollToHash();

    return () => unlisten();
  }, [history]);
}
